import { render, staticRenderFns } from "./OtaruDestroyList.vue?vue&type=template&id=083c46da&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./OtaruDestroyList.vue?vue&type=script&lang=ts&"
export * from "./OtaruDestroyList.vue?vue&type=script&lang=ts&"
import style0 from "./OtaruDestroyList.vue?vue&type=style&index=0&id=083c46da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083c46da",
  null
  
)

export default component.exports